<template>
  <div style="margin-left: 20px;margin-right: 30px;">
    <div class="bottom-solid-line display-flex" style="padding: 35px 0 0 0;">
      <div style="flex-basis: 20%">
        <span>选择空间：</span>
        <el-cascader
          @change="getDeviceList"
          :options="spaceTree"
          :props="defaultProps"
          change-on-select="true"
          clearable
          placeholder="请选择空间"
          size="mini"
          v-model="defaultForm.spaceIds">
        </el-cascader>
      </div>
      <div style="flex-basis: 20%">
        <span>选择类型：</span>
        <el-select
          @change="getDeviceList"
          placeholder="请选择类型"
          size="mini"
          v-model="defaultForm.typeId">
          <el-option
            :key="item.id"
            :label="item.cnName"
            :value="item.id"
            v-for="item in typeList">
          </el-option>
        </el-select>
      </div>
      <div style="flex-basis: 20%">
        <span>选择设备：</span>
        <el-select
          @change="getPointList"
          placeholder="请选择设备"
          size="mini"
          v-model="defaultForm.deviceId">
          <el-option
            :key="item.id"
            :label="item.name"
            :value="item.id"
            v-for="item in deviceList">
          </el-option>
        </el-select>
      </div>
      <div style="flex-basis: 20%">
        <span>选择测点：</span>
        <el-select
          clearable
          collapse-tags
          filterable
          multiple
          placeholder="请选择测点"
          size="mini"
          v-model="defaultForm.pointIds">
          <el-option
            :key="item.id"
            :label="item.name"
            :value="item.id"
            v-for="item in pointList">
          </el-option>
        </el-select>
      </div>
      <div class="text-right" style="flex-basis: 20%">
        <el-button style="margin-bottom: 5px;padding:9px 25px;color:rgba(7, 230, 248, 1)"
                   size="mini" @touchstart="addPoints" @click="addPoints">
          添加
        </el-button>
      </div>
    </div>

    <div class="margin-top-20 display-flex" v-if="pointTags.length">
      <div style="flex-basis: 75px">已选测点：</div>
      <div>
        <el-tag
          size="small"
          type="info"
          :key="tag"
          style="margin: 0 10px 5px 0;"
          v-for="tag in pointTags"
          closable
          :disable-transitions="false"
          @close="handleClose(tag)">
          {{ tag.deviceName }}-{{ tag.name }}
        </el-tag>
      </div>
    </div>

    <div style="margin-top: 50px">
      <div class="text-center" v-if="pointTags.length">
        <el-select v-model="curve" size="mini"
                   @change="getLineData"
                   style="width: 115px;margin-right: 10px">
          <el-option :value="1" label="实时曲线"></el-option>
          <el-option :value="2" label="历史曲线"></el-option>
        </el-select>
        <el-date-picker
          size="mini"
          v-if="curve === 2"
          v-model="month"
          type="daterange"
          align="right"
          unlink-panels
          @change="getLineData"
          value-format="yyyy-MM-dd HH:mm:ss"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions">
        </el-date-picker>

      </div>
      <dynamic-line-chart1 v-if="pointTags.length && lineData.time.length"
                           style="height: calc(100vh - 320px)"
                           :data="lineData" :extend-data="lineExtentData">
      </dynamic-line-chart1>
      <no-data v-else style="margin-top: 30vh"></no-data>
    </div>
  </div>
</template>

<script>
import {userDevice} from "@/network/device-info";
import {getSpaceTreeData} from "@/network/space-info";
import {getDeviceCategoryList} from "@/network/device-category";
import {listByDeviceId} from "@/network/device-measuring-point";
import DynamicLineChart1 from "@/components/echarts/DynamicLineChart1";
import NoData from "@/components/NoData";
import _ from 'lodash'
import {getPointMonthTrend, getPointValues} from "@/network/measuring-point-history";

export default {
  name: "DataCurve",
  components: {DynamicLineChart1, NoData},
  data() {
    return {
      deviceList: [],
      typeList: [],
      spaceTree: [],
      pointList: [],
      defaultProps: {
        label: 'title',
        value: 'id',
        children: 'children'
      },
      defaultForm: {
        spaceIds: [],
        pointIds: [],
        deviceId: null,
        deviceName: null,
        typeId: null,
      },
      pointTags: [],
      curve: 1,
      month: '',
      lineData: {
        time: [],
        data: {}
      },
      timer: null,
      pickerOptions: {
        shortcuts: [{
          text: '最近一天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近半年',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一年',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      //  倾斜度
      lineExtentData: {
        xAxis: [{
          axisLabel: {
            rotate: 45,
          }
        }]
      },
    }
  },
  mounted() {
    this.getSpaceTreeData()
    this.getDeviceCategoryList()
  },
  destroyed() {
    if ( this.timer ) {
      clearInterval(this.timer)
    }
  },
  methods: {
    //获取级联空间
    getSpaceTreeData() {
      getSpaceTreeData().then(res => {
        if ( res.code === 0 ) {
          this.spaceTree = res.data
        }
      });
    },
    // 设备类型列表
    getDeviceCategoryList() {
      getDeviceCategoryList().then(res => {
        if ( res.code === 0 ) {
          this.typeList = res.data;
        }
      });
    },
    // 设备列表
    getDeviceList() {
      this.deviceList = []
      this.defaultForm.deviceId = null
      this.defaultForm.deviceName = null
      this.pointList = []
      this.defaultForm.pointIds = []
      let spaceId = null
      if ( this.defaultForm.spaceIds.length ) {
        spaceId = this.defaultForm.spaceIds[this.defaultForm.spaceIds.length - 1]
      }
      userDevice(spaceId, this.defaultForm.typeId).then(res => {
        if ( res.code === 0 ) {
          this.deviceList = res.data;
        }
      });
    },
    getPointList() {
      this.pointList = []
      this.defaultForm.pointIds = []
      this.defaultForm.deviceName = this.deviceList.filter(item => item.id === this.defaultForm.deviceId)[0].name
      listByDeviceId(this.defaultForm.deviceId).then(res => {
        if ( res.code === 0 ) {
          this.pointList = res.data;
        }
      })
    },
    addPoints() {
      if ( this.defaultForm.pointIds.length < 1 ) {
        this.$message.error("请选择测点!")
        return false;
      }
      const points = []
      this.pointList.forEach(item => {
        if ( this.defaultForm.pointIds.indexOf(item.id) > -1 ) {
          item.deviceId = this.defaultForm.deviceId
          item.deviceName = this.defaultForm.deviceName
          points.push(item)
        }
      })
      this.pointTags = _.unionBy(points, this.pointTags, 'id')
      //获取测点曲线
      this.getLineData()
    },
    handleClose(tag) {
      this.pointTags = this.pointTags.filter(item => item.id !== tag.id)
      //获取测点曲线
      this.getLineData()
    },
    getLineData() {
      this.lineData = {
        time: [],
        data: {}
      }
      if ( this.pointTags.length ) {
        //获取实时数据
        if ( this.curve === 1 ) {
          this.getRealTimeData()
          this.timer = setInterval(this.getRealTimeData, 5000)
        } else {
          //获取历史数据
          if ( this.timer ) {
            clearInterval(this.timer)
          }
          if ( !this.month ) {
            // this.month = getFormatDate(new Date()).substring(0, 7)
          }
          this.getPointMonthTrend()
        }
      } else {
        if ( this.timer ) {
          clearInterval(this.timer)
        }
      }
    },
    //实时数据
    getRealTimeData() {
      const pointIds = this.pointTags.map(item => item.id)
      getPointValues(pointIds).then(res => {
        if ( res.code === 0 ) {
          pointIds.forEach((pointId, index) => {
            const pointItem = res.data[pointId];
            const history = pointItem.history;
            if ( history ) {
              //测点曲线值
              if ( this.lineData.data[pointId] === undefined ) {
                this.lineData.data[pointId] = {};
                this.lineData.data[pointId].name = history.deviceName + '-' + history.pointName;
                this.lineData.data[pointId].value = [];
              }
              if (this.lineData.data[pointId].value.length >= 20) {
                this.lineData.data[pointId].value.shift();
              }
              this.lineData.data[pointId].value.push(history.pointValue)
              //测点曲线时间
              if ( index === 0 ) {
                let minute = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes()
                let second = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds() : new Date().getSeconds()
                if (this.lineData.time.length >= 20) {
                  this.lineData.time.shift();
                }
                this.lineData.time.push(new Date().getHours() + ":" + minute + ":" + second)
              }
            }
          })
        }
      })
    },
    // 划分时间段，多次调用接口请求，避免数据量影响请求速度，当前最多一次7天
    async getPointMonthTrend() {
      const pointIds = this.pointTags.map(item => item.id);
      let size=0
      // 确保 this.month[0] 和 this.month[1] 是有效的日期字符串
      const startDateStr = this.month[0]; // "2025-01-13 00:00:00"
      const endDateStr = this.month[1]; // "2025-XX-XX HH:mm:ss" (替换为实际的结束日期)

      // 将日期字符串转换为 Date 对象
      // eslint-disable-next-line no-unused-vars
      const startDate = new Date(startDateStr);
      const endDate = new Date(endDateStr);

      // 定义请求间隔和每次请求的天数
      const intervalInMilliseconds = 100; // 100毫秒间隔
      const daysPerRequest = 7; // 每次请求7天的数据

      // 辅助函数，用于增加日期天数
      const addDays = (date, days) => {
        const newDate = new Date(date);
        newDate.setDate(newDate.getDate() + days);
        return newDate;
      };
      // 递归函数，用于分批请求数据
      const recursiveFetch = (currentStartDate) => {
        // 确保当前开始日期不超过总结束日期
        if (currentStartDate > endDate) {
          return;
        }

        // 计算当前请求的结束日期（不包括当前开始日期的那一天）
        const currentEndDate = addDays(new Date(currentStartDate), daysPerRequest - 1);
        // 如果计算的结束日期超过了总结束日期，则使用总结束日期的时间部分
        if (currentEndDate > endDate) {
          currentEndDate.setFullYear(endDate.getFullYear());
          currentEndDate.setMonth(endDate.getMonth());
          currentEndDate.setDate(endDate.getDate());
          currentEndDate.setHours(endDate.getHours());
          currentEndDate.setMinutes(endDate.getMinutes());
          currentEndDate.setSeconds(endDate.getSeconds());
          currentEndDate.setMilliseconds(endDate.getMilliseconds());
        }
        // 组装请求的开始时间
        const actualFormattedStartDate = `${currentStartDate.getFullYear()}-${String(currentStartDate.getMonth() + 1).padStart(2, '0')}-${String(currentStartDate.getDate()).padStart(2, '0')} ${String(currentStartDate.getHours()).padStart(2, '0')}:${String(currentStartDate.getMinutes()).padStart(2, '0')}:${String(currentStartDate.getSeconds()).padStart(2, '0')}`;
        // 组装请求的结束时间
        const actualFormattedEndDate = currentEndDate >= endDate ? endDateStr : `${currentEndDate.getFullYear()}-${String(currentEndDate.getMonth() + 1).padStart(2, '0')}-${String(currentEndDate.getDate()).padStart(2, '0')} ${String(currentEndDate.getHours()).padStart(2, '0')}:${String(currentEndDate.getMinutes()).padStart(2, '0')}:${String(currentEndDate.getSeconds()).padStart(2, '0')}`;

        // 构造请求参数
        const params = {
          endDate: actualFormattedEndDate,
          startDate: actualFormattedStartDate,
          pointIdList: pointIds
        };

        // 发送请求并处理响应
        getPointMonthTrend(params).then(res => {
          if (res.code === 0) {
            // 通过判断size=0来曲儿
            if(size==0 && JSON.stringify(res.data.data) !== '{}'){
              this.lineData=res.data
              size=1
            }else if(size!=0 && JSON.stringify(res.data.data) !== '{}'){
              // 遍历res.data.data中的每个点
              let timeSize=0
              for (const pointId in res.data.data) {
                // eslint-disable-next-line  no-prototype-builtins
                if (res.data.data.hasOwnProperty(pointId)) {
                  // eslint-disable-next-line  no-prototype-builtins
                  if(this.lineData.data.hasOwnProperty(pointId)){
                    this.lineData.data[pointId].value.push(...res.data.data[pointId].value)
                    if( timeSize==0){
                      // 每次请求只有第一次需要加时间轴
                      this.lineData.time.push(...res.data.time)
                      timeSize++
                    }
                  }
                }
              }
            }{
              // 是第一次但没有数据
              // 不是
            }
            // 准备下一次递归调用
            const nextStartDate = addDays(new Date(actualFormattedEndDate), 1);
            setTimeout(() => recursiveFetch(nextStartDate), intervalInMilliseconds);
          } else {
            console.error('请求失败', res);
          }
        }).catch(error => {
          console.error('请求出错', error);
        });
      };
      // 开始递归请求数据
      recursiveFetch(new Date(startDateStr));
    }
  }
}
</script>

<style scoped>

</style>
